import { DanaGeneralSettingModel } from "@dana/Types/ApiModels";
import { CartModel } from "@insite/client-framework/Types/ApiModels";


export const metMinimumOrderAmount = (
    cart: CartModel | null | undefined,
    danaGeneralSettings: DanaGeneralSettingModel | null | undefined,
): boolean => {
    return (cart && danaGeneralSettings) ? (cart.orderGrandTotal >= danaGeneralSettings.minAnnualReturnsAmount) : false;
};

export const containsNonReturnableItems = (cart: CartModel | null | undefined): boolean => {
    return !!cart && !!cart.cartLines && cart.cartLines.some(line => line.properties?.isReturnable !== "true");
}

export const exceedBalance = (
    cart: CartModel | null | undefined,
    balance: number,
): boolean => {
    return (cart && balance) ? (cart.orderGrandTotal > balance) : false;
};


